<template>
  <transition name="c-gnav">
  <div v-show="isShowGnav" class="c-gnav" :class="{'c-gnav--mobile': isMobile}">
    <div class="c-gnavWrap">
      <!-- グロナビPC -->
      <div class="c-gnavWrap__side">
        <transition name="c-gnavWrap__sideSns">
        <div v-show="isShowGnav" class="c-gnavWrap__sideSns">
          <ul>
            <li><a class="c-btnFacebook c-btnFacebook--hoverOp c-btnFacebook--white c-btnFacebook--noborder" :href="urls.facebook" target="_blank" rel="noopener"></a></li>
            <li><a class="c-btnTwitter c-btnTwitter--hoverOp c-btnTwitter--white c-btnTwitter--noborder" :href="urls.twitter" target="_blank" rel="noopener"></a></li>
            <li><a class="c-btnInsta c-btnInsta--hoverOp c-btnInsta--white c-btnInsta--noborder" :href="urls.insta" target="_blank" rel="noopener"></a></li>
            <li><a class="c-btnYoutube c-btnYoutube--hoverOp c-btnYoutube--white c-btnYoutube--noborder" :href="urls.youtube" target="_blank" rel="noopener"></a></li>
          </ul>
        </div>
        </transition>
      </div>

      <div ref="c-gnavWrap__nav" class="c-gnavWrap__nav">
        <div class="c-gnavWrap__navWrap">
        <transition name="c-gnavWrap__sideLogo">
          <div v-show="isShowGnav" class="c-gnavWrap__sideLogo">
            <a href="/">
              <picture>
                <source media="(max-width: 900px)" :srcset="`${assets_path}img/common/logo-pics-b.svg`" />
                <img :src="`${assets_path}img/common/logo-pics-v.svg`" alt="P.I.C.S" width="40" height="184" />
              </picture>
            </a>
          </div>
        </transition>
        <transition name="c-gnavWrap__navPages">
        <div ref="c-gnavWrap__navPages" v-show="isShowGnav" class="c-gnavWrap__navPages">
          <div class="c-gnavWrap__navPages__wrap">
            <h2 class="c-navCaption">CONTENTS</h2>
            <ul class="c-gnavWrap__navPages__wrapLinks1 f-ITC-BoldIt">
              <li><a href="/">TOP</a></li>
              <li><a href="/news/">NEWS</a></li>
              <li><a href="/works/">WORKS</a></li>
              <li><a href="/member/">MEMBER</a></li>
              <li><a href="/creator/">CREATOR</a></li>
              <li><a href="/company/">COMPANY</a></li>
            </ul>
          </div>
          <div class="c-gnavWrap__navPages__wrap">
            <h2 class="c-navCaption">DIVISION</h2>
            <ul class="c-gnavWrap__navPages__wrapLinks3">
              <li><a href="/tech/"><img class="icon-tech" :src="`${assets_path}img/common/logo-pics-tech.svg`" alt="P.I.C.S. TECH" width="126" height="50" /></a></li>
              <li><a href="/live/"><img class="icon-live" :src="`${assets_path}img/common/logo-pics-live.png`" alt="P.I.C.S. LIVE" width="126" height="50" /></a></li>
              <li><a href="/st/"><img class="icon-st" :src="`${assets_path}img/common/logo-pics-st@2x.png`" alt="P.I.C.S. ST" width="118" height="51" /></a></li>
              <li><a href="/c4n/"><img class="icon-c4n" :src="`${assets_path}img/c4n/logo-black.png`" alt="P.I.C.S. C4N" width="211" height="50" /></a></li>
              <li><a href="https://hept.tokyo/" target="_blank"><img class="icon-hept" :src="`${assets_path}img/common/logo-hept.png`" alt="HEPT" width="188" height="43" /></a></li>
            </ul>
          </div>
          <div class="c-gnavWrap__navPages__wrap">
            <h2 class="c-navCaption">INQUIRY</h2>
            <ul class="c-gnavWrap__navPages__wrapLinks2 f-ITC-BoldIt">
              <li><a href="/recruit/">RECRUIT</a></li>
              <li><a href="/contact/">CONTACT</a></li>
              <li><a href="/company/?anchor=p-company__info">ACCESS</a></li>
            </ul>
          </div>
          <!-- PC用 -->
          <div class="c-gnavWrap__navPages__wrap u-none-b--pc">
            <div class="c-toggleLang">
              <ul class="f-ITC-BoldIt">
                <li><a href="/"><span>JP</span></a></li>
                <li><a href="/en/"><span>EN</span></a></li>
              </ul>
            </div>

            <ul class="c-gnavWrap__navPages__wrapLinks4 f-ITC-BoldIt">
              <li><a href="/privacy-policy/">PRIVACY POLICY</a></li>
            </ul>

            <address class="c-gnavWrap__navPages__wrapAddress">
              <p>東京都渋谷区恵比寿南3-9-19<br>サイシンビル<a class="c-btnMap c-btnMap--b" :href="urls.map" target="_blank" rel="noopener"><span>MAP</span></a></p>
            </address>
          </div>
          <!-- /PC用 -->
        </div>
        </transition>

        <transition name="c-gnavWrap__navTopics">
        <div ref="c-gnavWrap__navTopics" v-show="isShowGnav" class="c-gnavWrap__navTopics">
          <div class="c-gnavWrap__navTopics__wrap">
            <h2 class="c-navCaption">HEADLINE</h2>

            <ul class="c-gnavWrap__navTopics__wrapList">
              <li v-for="(item, index) in topics">
                <a :href="item.url">
                  <div>
                    <div>
                      <span v-for="(value) in item.category" class="c-cate">{{value}}</span>
                    </div>
                    <span>{{item.date}}</span>
                  </div>
                  <p v-html="item.title"></p>
                </a>
              </li>
            </ul>

            <a class="c-gnavWrap__navTopics__wrapMore f-ITC-BoldIt" href="/news/">
              <span>MORE</span>
            </a>
          </div>
        </div>
        </transition>
        </div>
      </div>
      <!-- スマホ用 -->
      <div class="c-gnavWrap__navPages__wrap u-none-b--sp">
        <div class="c-gnavWrap__navPages__wrapLang">
          <ul class="f-ITC-BoldIt">
            <li><a href="/">JP</a></li>
            <li><a href="/en/">EN</a></li>
          </ul>
        </div>

        <ul class="c-gnavWrap__navPages__wrapLinks4 f-ITC-BoldIt">
          <li><a href="/privacy-policy/">PRIVACY POLICY</a></li>
        </ul>

        <address class="c-gnavWrap__navPages__wrapAddress">
          <p>東京都渋谷区恵比寿南3-9-19<br>サイシンビル<a class="c-btnMap c-btnMap--b" :href="urls.map" target="_blank" rel="noopener"><span>MAP</span></a></p>
        </address>
      </div>
      <!-- /スマホ用 -->
    </div>
    <div class="c-gnav__trigger" @click="closeGnav">
      <transition name="c-gnav__triggerCross">
      <div v-show="isShowGnav" class="c-gnav__triggerCross">
        <span></span>
        <span></span>
      </div>
      </transition>
    </div>
  </div>
  </transition>
</template>

<script>
  import PerfectScrollbar from 'perfect-scrollbar';
  import { breakpoint, assets_path } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';
  import BtnSquare from '@/_components/btn-square.vue';

  export default {
    components: {
      BtnSquare
    },
    data() {
      return {
        assets_path: assets_path,
        isMobile: false,
        ispc: false,
        isSetting: false,
        urls: {},
        psNav: null,
        psTopics: null,
        ps: null,
        topics: []
      }
    },
    store,
    watch: {
      isShowGnav (val) {
        if (val) {
          // open
          this.$nextTick(this.setting);
          if ($scrollManager) $scrollManager.xStopScroll();
        } else {
          // close
          this.reset();
          if ($scrollManager) $scrollManager.xStartScroll();
        }
      }
    },
    computed: {
      isShowGnav: function () {
        return this.$store.getters.isShowGnav
      }
    },
    created() {

    },
    mounted() {
      this.isMobile = this.$store.getters.isMobile;
      this.urls = this.$store.getters.getUrls;
      this.topics = JSON.parse(document.getElementById('js-param-headline').textContent);

      this.$nextTick(() => {
        this.resize();
      });
    },
    methods: {
      closeGnav() {
        this.$store.commit('setShowGnav', false);
      },
      resize() {
        if (window.innerWidth > breakpoint) {
          if (!this.ispc) {
            // スマホからpcに変更
            this.settingScroll();
          }
          this.ispc = true;
        } else {

          if (this.ispc) {
            // pcからスマホに変更
            this.resetScroll();
          }
          this.ispc = false;
        }
      },
      setting() {
        window.addEventListener('resize', this.resize);
        // scrollbar
        this.settingScroll();
      },
      settingScroll() {
        if (this.isSetting) return;
        if (this.isMobile) {
          this.$refs['c-gnavWrap__navPages'].scrollTop = 0;
          this.$refs['c-gnavWrap__navTopics'].scrollTop = 0;
          this.$refs['c-gnavWrap__nav'].scrollTop = 0;
        } else {
          this.isSetting = true;
          this.psNav = new PerfectScrollbar(this.$refs['c-gnavWrap__navPages']);
          this.psTopics = new PerfectScrollbar(this.$refs['c-gnavWrap__navTopics']);
          this.ps = new PerfectScrollbar(this.$refs['c-gnavWrap__nav']);
          this.$refs['c-gnavWrap__navPages'].scrollTop = 0;
          this.$refs['c-gnavWrap__navTopics'].scrollTop = 0;
          this.$refs['c-gnavWrap__nav'].scrollTop = 0;
        }
      },
      reset() {
        window.removeEventListener('resize', this.resize);
        // scrollbar
        this.resetScroll();
      },
      resetScroll() {
        this.isSetting = false;

        if (this.isMobile) {

        } else {
          if (this.psNav) {
            this.psNav.destroy();
            this.psNav = null;
          }
          if (this.psTopics) {
            this.psTopics.destroy();
            this.psTopics = null;
          }
          if (this.ps) {
            this.ps.destroy();
            this.ps = null;
          }
        }
      }
    }
  }
</script>
